import { registerFunctionalComponent } from 'js/lib/components/component'
import { openCloudinaryWidget, isCloudinaryWidgetOpen, preloadCloudinaryWidget } from 'js/lib/cloudinary'

registerFunctionalComponent('.js-c-img-upload-input', 'ImageUploader', ImageUploader)

function ImageUploader(component) {
  preloadCloudinaryWidget()

  component.useHandler(() => {
    const button = component.element.querySelector('.js-c-img-upload-input__button')
    if (!button) return

    const handler = event => {
      event.preventDefault()
      handleImageUpload(component.element)
    }

    button.addEventListener('click', handler)
    return () => button.removeEventListener('click', handler)
  })
}

async function handleImageUpload(element) {
  if (isCloudinaryWidgetOpen()) return

  const { tag, allowedFormats, maxImageWidth, maxImageHeight, minImageWidth, minImageHeight } = JSON.parse(
    element.dataset.clientState
  )

  const errorEl = element.querySelector('.js-c-img-upload-input__error')

  // Clear any previous error when re-opening the widget
  if (errorEl) {
    errorEl.textContent = ''
    errorEl.classList.add('tw-hidden')
  }

  let results

  try {
    results = await openCloudinaryWidget({
      uploadPreset: 'no_transforms',
      tags: [tag],
      multiple: false,
      sources: ['local', 'url'],
      maxFileSize: 25 * 100000, // 25 MB
      resourceType: 'image',
      allowedFormats,
      maxImageWidth,
      maxImageHeight,
      minImageWidth,
      minImageHeight,
    })
  } catch (error) {
    if (errorEl) {
      errorEl.textContent = 'Image upload failed. Please try again.'
      errorEl.classList.remove('tw-hidden')
    }
    return
  }

  if (!results.length) {
    if (errorEl) {
      const hiddenInput = element.querySelector('.js-c-img-upload-input__hidden-input')
      // Only show the error if no image has been previously uploaded
      if (!hiddenInput || !hiddenInput.value) {
        errorEl.textContent = 'Image could not be uploaded. Please check the file meets the requirements and try again.'
        errorEl.classList.remove('tw-hidden')
      }
    }
    return
  }

  // Upload succeeded — clear any error
  if (errorEl) {
    errorEl.textContent = ''
    errorEl.classList.add('tw-hidden')
  }

  const info = results[0].info
  const imageUrl = info.secure_url

  const thumbnailUrl = imageUrl.replace('/upload/', '/upload/h_176,c_fit,q_auto,f_auto/')

  const thumbnailContainer = element.querySelector('.js-c-img-upload-input__thumbnail')
  const img = thumbnailContainer.querySelector('img')
  const hiddenInput = element.querySelector('.js-c-img-upload-input__hidden-input')

  thumbnailContainer.classList.remove('hidden')
  thumbnailContainer.classList.add('tw-animate-pulse', 'tw-bg-neutral-100')

  const tempImg = new Image()
  tempImg.onload = () => {
    thumbnailContainer.classList.remove('tw-animate-pulse', 'tw-bg-neutral-100', 'tw-hidden')
    img.src = thumbnailUrl
  }
  tempImg.onerror = () => {
    img.src = imageUrl
    thumbnailContainer.classList.remove('tw-animate-pulse', 'tw-bg-neutral-100', 'tw-hidden')
  }
  tempImg.src = thumbnailUrl

  hiddenInput.value = imageUrl
}
